import React from 'react';
// components
import { DescriptionList } from '@ems/client-design-system';
import { displayNADPSpeed, displayAltitude } from 'src/utils/unitsOfMeasurement';
import { useLanguageSelectors, useGeometrySelectors } from 'src/@app/reducers';
import { getGeometryType } from 'src/utils';
import { GATE_INFRINGEMENT } from 'src/constants';

export const GatesDetailsContainer = ({ infringement }) => {
  let items: any = [];

  // Translation
  const languageSelectors = useLanguageSelectors();
  const {
    components: {
      lists: { gateInfractions },
    },
    fields: {
      gates: { gate, infraction, altitude, speed },
    },
  } = languageSelectors.getLanguage();
  const geometrySelectors = useGeometrySelectors();
  const gateGeometry = geometrySelectors.getGeometry(getGeometryType(GATE_INFRINGEMENT));
  const geometryFeatures = gateGeometry ? gateGeometry.features : [];

  if (infringement) {
    const feature = geometryFeatures.find(e => e.id === infringement.gateId.toString());
    const name = feature ? feature.properties.name : '';
    items = [
      {
        title: gate,
        description: name,
      },
      {
        title: infraction,
        description: gateInfractions[infringement.reason],
      },
      {
        title: altitude,
        description: displayAltitude(infringement.position.altitude),
      },
      {
        title: speed,
        description: displayNADPSpeed(infringement.speed),
      },
    ];
  } else {
    items = [
      {
        title: gate,
        description: null,
      },
      {
        title: infraction,
        description: null,
      },
      {
        title: altitude,
        description: null,
      },
      {
        title: speed,
        description: null,
      },
    ];
  }

  return <DescriptionList items={items} loading={!infringement} />;
};
